import React from 'react'

interface StatusMetricProps {
  value: string | number
  label: string
  variant?: 'primary' | 'success' | 'warning' | 'info' | 'error'
  className?: string
}

export const StatusMetric: React.FC<StatusMetricProps> = ({
  value,
  label,
  variant = 'primary',
  className = '',
}) => {
  const variantClasses = {
    primary: 'text-purple-600 dark:text-purple-400',
    success: 'text-green-600 dark:text-green-400',
    warning: 'text-yellow-600 dark:text-yellow-400',
    info: 'text-blue-600 dark:text-blue-400',
    error: 'text-red-600 dark:text-red-400'
  }

  return (
    <div className={`text-center ${className}`}>
      <div className={`text-2xl font-bold ${variantClasses[variant]}`}>
        {value}
      </div>
      <div className="text-sm text-gray-600 dark:text-gray-400">
        {label}
      </div>
    </div>
  )
} 